module.exports = __webpack_public_path__ + "static/img/bs_content5.520f596.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bs_content5.png
// module id = jhKc
// module chunks = 0